<cb-dialog dialogHeading="View Quote Variation Orders">
    @if (isLoaded && variationOrders.length < 1) {
        <cb-info-message message="There are no variations to display"> </cb-info-message>
    }
    @if (!isLoaded) {
        <cb-loading-spinner></cb-loading-spinner>
    }
    @if (isLoaded && variationOrders.length > 0) {
        @for (variation of variationOrders; track variation) {
            <mat-list-item>
                <div mat-line>
                    VO #{{ variation.variationNumber }} -
                    {{ variation.costNature | cbEnumToLabel: COST_NATURE_ENUM }}
                    @if (variation.costNature === COST_NATURE_ENUM.ExtraToClient) {
                        <span>{{ variation.variationTotal | cbCurrency: 'addGst' }}</span>
                    }
                    @if (variation.costNature !== COST_NATURE_ENUM.ExtraToClient) {
                        <span>{{ variation.variationTotal | cbCurrency }}</span>
                    }
                </div>
            </mat-list-item>
        }
    }
</cb-dialog>
